__turbopack_context__.v({
  "labelWrapper": "MakeFilter-module__sbOgIG__labelWrapper",
  "makes": "MakeFilter-module__sbOgIG__makes",
  "popularMakesTitle": "MakeFilter-module__sbOgIG__popularMakesTitle",
  "resetButton": "MakeFilter-module__sbOgIG__resetButton",
  "searching": "MakeFilter-module__sbOgIG__searching",
});
